import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { darklyClientId } from '@/config';
import { APP_FLAGS } from '@/config/flags';

// See https://launchdarkly.github.io/node-client-sdk/interfaces/LDOptions.html
const LDOptions = {
  sendEventsOnlyForVariation: true,
  application: {
    id: 'cw-onboarding'
  }
};

const initializeLDProvider = async () => {
  return await asyncWithLDProvider({
    clientSideID: darklyClientId,
    context: {
      kind: 'user',
      key: 'anonymous-user-cw-onboarding',
      anonymous: true
    },
    options: LDOptions,
    reactOptions: {
      useCamelCaseFlagKeys: false
    },
    flags: {
      [APP_FLAGS.USE_NEW_VALIDATION_CARD_RULES]: false,
      [APP_FLAGS.BUSINESS_NAME_ON_SIGNUP_FORM]: false,
      [APP_FLAGS.ENABLE_3DS_VERIFICATION]: false,
      [APP_FLAGS.ENABLE_AUTH0_UNIVERSAL_LOGIN]: false
    }
  });
};

export default initializeLDProvider;
